import type { FC } from 'react';

import type { ActiveDocMeta, NavTreeItem, NavTree as INavTree } from '@models/NavigationTree';
import { NavTreeElement } from '../NavTreeElement/NavTreeElement';
import { NavItemWrapper, NavListWrapper } from './NavTree.styles';

type NavTreeProps = {
  navTree: INavTree;
  isOpened: boolean;
  activeDocMeta: ActiveDocMeta;
};

export const NavTree: FC<NavTreeProps> = ({ navTree, isOpened, activeDocMeta }) => (
  <NavListWrapper opened={isOpened}>
    {isOpened &&
      navTree.map((item: NavTreeItem) => (
        <NavItemWrapper key={item.path} className={item.divider ? 'divider' : ''} data-testid="navigation-item">
          <NavTreeElement item={item} activeDocMeta={activeDocMeta} />
        </NavItemWrapper>
      ))}
  </NavListWrapper>
);
